module.exports = __webpack_public_path__ + "static/OGImage_websummit-59e349c547fe7aeee29c5fa6273ced8c.png";